var _defs, _circle, _circle2, _path, _polygon, _rect, _polygon2, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeampriceidea01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/1000/svg",
    viewBox: "0 0 71 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#86d1d7;}.cls-2{fill:none;stroke:#282567;stroke-miterlimit:10;}.cls-3{fill:#282567;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.5,
    cy: 35.5,
    r: 35.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 35.5,
    cy: 35.5,
    r: 31
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.24,17.39a12.85,12.85,0,0,0-19.48,0,14.2,14.2,0,0,0-3.65,9.25A17.48,17.48,0,0,0,25.25,36a15.27,15.27,0,0,1,.93,1.67A15.56,15.56,0,0,1,27.42,42l2.22-.32a18,18,0,0,0-1.38-4.8,13.07,13.07,0,0,0-1.1-2,15.31,15.31,0,0,1-2.81-8.2c0-5.43,4.58-11.49,11.15-11.49s11.15,6.06,11.15,11.49a15.31,15.31,0,0,1-2.81,8.2,14,14,0,0,0-1.1,2,18,18,0,0,0-1.38,4.8l2.22.32a15.56,15.56,0,0,1,1.24-4.31A15.27,15.27,0,0,1,45.75,36a17.48,17.48,0,0,0,3.14-9.36A14.22,14.22,0,0,0,45.24,17.39Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "34.38 41.84 36.62 41.84 36.62 41.84 36.62 34.88 41.59 29.91 40.01 28.33 35.5 32.84 30.99 28.33 29.41 29.91 34.38 34.88 34.38 41.84 34.38 41.84"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 29.02,
    y: 43.48,
    width: 12.97,
    height: 2.24
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "30.54 55.92 34.64 58.08 36.56 58.08 40.46 55.92 40.46 54.2 30.54 54.2 30.54 55.92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42,47.06H29a1.12,1.12,0,0,0,0,2.24H42a1.12,1.12,0,1,0,0-2.24Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42,50.62H29a1.12,1.12,0,0,0,0,2.24H42a1.12,1.12,0,0,0,0-2.24Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeampriceidea01);
export default __webpack_public_path__ + "static/media/teampriceidea-01.e2f28146ca61fae5e576631f75ab0e36.svg";
export { ForwardRef as ReactComponent };